export default __webpack_public_path__ + "static/pixel-rectangle-blue-a47c73f7b34bd33bb593fba0674c6c22.svg";